import { formatContactNameList, formatDate } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Link } from 'react-router-dom'
import { Table } from 'reactstrap'
import './PipelineDates.scss'
import { PipelinePageProps } from './PipelinePage'

export default class PipelineDates extends React.PureComponent<
  PipelinePageProps
> {
  public render() {
    return (
      <DocumentTitle title={`${this.props.pipeline.name} :: Dates`}>
        <div>
          <Table className='critical-dates-table' hover size='sm' striped>
            <thead>
              <tr>
                <th className='complete-col' />
                <th className='due-date-col'>Due Date</th>
                <th className='title-col'>Title</th>
                <th className='assigned-to-col'>Assigned to</th>
              </tr>
            </thead>
            <tbody>
              {this.props.pipeline.criticalDates
                .sortBy((cd) => (cd === undefined ? undefined : cd.dueDate))
                .toArray()
                .map((critDate) => (
                  <tr key={critDate.id}>
                    <td className='complete-col'>
                      {critDate.isComplete ? (
                        <FontAwesomeIcon
                          className='text-primary'
                          icon={['far', 'check']}
                          fixedWidth
                        />
                      ) : null}
                    </td>
                    <td className='due-date-col'>
                      {formatDate(critDate.dueDate, 'MM/DD/YYYY')}
                    </td>
                    <td className='title-col'>
                      <Link to={`/assignment/${critDate.id}`} target='_blank'>
                        {critDate.title}
                      </Link>
                    </td>
                    <td className='assigned-to-col'>
                      {formatContactNameList(critDate.assignedTo)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </DocumentTitle>
    )
  }
}
